import { ShowAllButton } from "./ShowAllButton";

export function NoResults({ setShowMobileFilters }) {
  return (
    <div className="mx-auto max-w-prose my-40 p-10 ">
      <h2>No Results</h2>
      <p className="">
        If you can't find what you're looking for, please contact us! We have
        even more options in shop and our customer service team can cross
        reference our boats and patterns to help you find what you need. (If we
        can't help you, we will do our best to point you in the right direction.
      </p>
      <div className="flex items-center gap-6">
        <a href="/contact-us/" className="button">
          Contact Us
        </a>
        <div className="pt-2 px-3">
          <ShowAllButton setShowMobileFilters={setShowMobileFilters} />
        </div>
      </div>
    </div>
  );
}
